// import Cookies from "universal-cookie";

// const cookies = new Cookies();

export const getPaymentsDue = async () => {

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_CMS}/api/stripe/webhook/payments_due`,
     // 'http://localhost:3000/api/stripe/create/customer_portal',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "X-CSRFToken": cookies.get("boho_csrf"),
          // "X-CSRF-Token": cookies.get("boho_csrf"),
        },
       // body: new URLSearchParams(data),
        credentials: "include",
      },
    );
  
    if (response.status === 200) {
      return await response.json();
    }

    return null;
  };
  